import { isNullOrUndefined } from "../utils/todo-utils";
export function getTopOfTree(todo) {
    let ret = todo;
    if (todo.parent) {
        ret = getTopOfTree(findBy$IdInTreeList(todo.parent.$ref));
    }
    return ret;
}

export function findInTreeList(todos, match) {
    let found;
    visitTreeList(
        todos,
        (todo) => found = todo,
        (todo) => {
            const matched = match(todo);
            return [matched, matched];
        });
    return found;
}
export function visitTreeList(todos, visit, match = (todo) => [true, false], recurse = (todo) => true) {
    for (const todo of todos) {
        const [matched, stop] = match(todo);
        if (matched) { visit(todo); }
        if (stop) { break; }
        if (todo.children && todo.children.length && recurse(todo)) { visitTreeList(todo.children, visit, match, recurse); }
    }
}


export function findByIdInTreeList(todos, id) {
    return findInTreeList(todos, found => found.id === id);
}

export function findByTitleInTreeList(todos, title) {
    return findInTreeList(todos, found => found.title === title);
}

export function findBy$IdInTreeList(todos, id) {
    return findInTreeList(todos, found => found.$id === id);
}

export function findAllProjectIdsInTreeList(todos, id) {
    let projects = [];
    for (const project of todos) {
        if (project.id !== id) {
            projects.push(project.id);
        }
    }

    return projects;
} 

export function getChildrenByRefId(projects, parentId) {

    let children = [];
    for (const project of projects) {
        if (project.$id === parentId) {
            for (const todo of project.children) {
                children.push(todo);
            }

            return children;
        }
    }
}

export function getParentIdByRefId(projects, ref) {

    let p = '';
    for (const project of projects) {
        if (project.$id === ref) {
            p = project.id;
            return p;
        }
    }
}

export function findRootProjects(projects) {

    let p = [];
    for (const project of projects) {
        p.push(project);
    }

    return p;
}

export function findOtherProjects(projects, id) {

    let p = [];
    for (const project of projects) {
        if (project.id !== id && project.isCompleted === false && (project.type === 1 || project.children.length > 0)) {
            p.push(project);
        }
    }

    return p;
}

export function getChildrenById(projects, id) {

    let project = findByIdInTreeList(projects, id);
    let children = [];
    for (const c of project.children) {
        children.push(c);
    }

    return children;
}

export function getParentId(projects, parentId) {
    for (const project of projects) {
        if (project.$id === parentId) {
            return project.id;
        }
    }
}

export function getParentInfoById(projects, parentId) {
    for (const project of projects) {
        if (project.id === parentId) {
            return project;
        }
    }
}

export function getSubProjectChildrenDetails(project, id) {

    const child = findByIdInTreeList(project, id);
    let details = [];

    for (const c of child.children) {
        details.push({
            Title: c.title,
            Description: (isNullOrUndefined(c.description)) ? '' : c.description,
            VisualSize: c.visualSize,
            Color: (isNullOrUndefined(c.color)) ? '#80C3E9' : (isNullOrUndefined(c.color.hexString)) ? '#80C3E9' : c.color.hexString,
            Type: c.type.toString(),
            ParentTitle: child.title
        });
    }

    return { Details: details, TopLevelTask: false };
}

export function getChildrenDetails(project, id, parentTitle) {

    const c = findByIdInTreeList(project, id);
    let details = [];

    details.push({
        Title: c.title,
        Description: (isNullOrUndefined(c.description)) ? '' : c.description,
        VisualSize: c.visualSize,
        Color: (isNullOrUndefined(c.color)) ? '#80C3E9' : (isNullOrUndefined(c.color.hexString)) ? '#80C3E9' : c.color.hexString,
        Type: c.type.toString(),
        ParentTitle: parentTitle
    });

    return { Details: details, TopLevelTask: true };
}

export function checkForSubProjects(projects, parentID) {

    //Update any globalPriority nulls in children of project
    for (const project of projects) {
        if (project.$id === parentID) {
            for (const todo of project.children) {
                if (isNullOrUndefined(todo.globalPriority)) {
                    return true;
                }
            }
        }
    }
    return false;
}

export function prioritizeUnprioritizedTasks(projects, parentID) {
    let priorities = [];

    // Get all globalPriority values for all projects
    for (const project of projects) {
        for (const todo of project.children) {
            if (!isNullOrUndefined(todo.globalPriority)) {
                priorities.push(todo.globalPriority);
            }
        }
    }

    if (priorities.length === 0) return;

    // Get max globalPriority value
    let max = Math.max(...priorities);
    let priorityUpdate = []

    //Update any globalPriority nulls in children of project
    for (const project of projects) {
        if (project.$id === parentID) {
            for (const todo of project.children) {
                if (isNullOrUndefined(todo.globalPriority)) {
                    max++;
                    const json = {
                        id: todo.id,
                        priority: max
                    }
                    priorityUpdate.push(json);
                }
            }

            return priorityUpdate;
        }
    }
}
